import React from 'react';
import { X } from 'lucide-react';

const FormPreview = ({ formType, formData, onClose }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const parseFormData = (data) => {
    try {
      return typeof data === 'string' ? JSON.parse(data) : data;
    } catch (error) {
      console.error('Error parsing form data:', error);
      return {};
    }
  };

  const renderW9Preview = (data) => {
    const formInfo = parseFormData(data.form_data);
    
    return (
      <div className="form-preview-content">
        <div className="form-header">
          <h2>Form W-9</h2>
          <p>Request for Taxpayer Identification Number and Certification</p>
          <p className="submission-date">Submitted: {formatDate(data.created_at)}</p>
        </div>

        <div className="form-section">
          <h3>Part I - Taxpayer Identification</h3>
          <div className="form-row">
            <label>Name:</label>
            <span>{formInfo.name || 'N/A'}</span>
          </div>
          <div className="form-row">
            <label>Business Name:</label>
            <span>{formInfo.business_name || 'N/A'}</span>
          </div>
          <div className="form-row">
            <label>Federal Tax Classification:</label>
            <span>{formInfo.federal_tax_classification || 'N/A'}</span>
          </div>
        </div>

        <div className="form-section">
          <h3>Part II - Address</h3>
          <div className="form-row">
            <label>Address:</label>
            <span>{formInfo.address || 'N/A'}</span>
          </div>
          <div className="form-row">
            <label>City, State, ZIP:</label>
            <span>{`${formInfo.city || ''}, ${formInfo.state || ''} ${formInfo.zip_code || ''}`.trim()}</span>
          </div>
        </div>

        <div className="form-section">
          <h3>Part III - Taxpayer Identification Number</h3>
          <div className="form-row">
            <label>TIN Type:</label>
            <span>{formInfo.tin_type === 'ssn' ? 'Social Security Number' : 'Employer Identification Number'}</span>
          </div>
          <div className="form-row">
            <label>TIN:</label>
            <span>{formInfo.ssn || formInfo.ein || 'N/A'}</span>
          </div>
        </div>

        <div className="form-section">
          <h3>Part IV - Certification</h3>
          <div className="form-row">
            <label>Digital Signature:</label>
            <span>{formInfo.digital_signature || 'N/A'}</span>
          </div>
          <div className="form-row">
            <label>Date:</label>
            <span>{formatDate(data.created_at)}</span>
          </div>
        </div>
      </div>
    );
  };

  const renderW8BENPreview = (data) => {
    const formInfo = parseFormData(data.form_data);
    
    return (
      <div className="form-preview-content">
        <div className="form-header">
          <h2>Form W-8BEN</h2>
          <p>Certificate of Status of Beneficial Owner for United States Tax Withholding and Reporting</p>
          <p className="submission-date">Submitted: {formatDate(data.created_at)}</p>
        </div>

        <div className="form-section">
          <h3>Part I - Identification of Beneficial Owner</h3>
          <div className="form-row">
            <label>Name:</label>
            <span>{formInfo.name || 'N/A'}</span>
          </div>
          <div className="form-row">
            <label>Country of Citizenship:</label>
            <span>{formInfo.country_of_citizenship || 'N/A'}</span>
          </div>
          <div className="form-row">
            <label>Permanent Residence Address:</label>
            <span>{formInfo.permanent_address || 'N/A'}</span>
          </div>
        </div>

        <div className="form-section">
          <h3>Part II - Claim of Tax Treaty Benefits</h3>
          <div className="form-row">
            <label>Country of Residence:</label>
            <span>{formInfo.country_of_residence || 'N/A'}</span>
          </div>
        </div>

        <div className="form-section">
          <h3>Certification</h3>
          <div className="form-row">
            <label>Digital Signature:</label>
            <span>{formInfo.digital_signature || 'N/A'}</span>
          </div>
          <div className="form-row">
            <label>Date:</label>
            <span>{formatDate(data.created_at)}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="form-preview-modal-overlay" onClick={onClose}>
      <div className="form-preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="form-preview-header">
          <h2>Form Preview</h2>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        
        <div className="form-preview-body">
          {formType === 'w9' ? renderW9Preview(formData) : renderW8BENPreview(formData)}
        </div>
        
        <div className="form-preview-footer">
          <button className="btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormPreview;
